import NavBar from './index.vue';
export default NavBar;
